type Pages = "home" | "estimation" | "expire" | "exceed" | "error" | "notfound" | "complete";

type Routings = {
  [T in Pages]: {
    location: string;
    parent: Pages | null;
    label: string;
  };
};

const routings: Routings = {
  home: {
    location: "/",
    parent: null,
    label: "TOPページ",
  },
  complete: {
    location: "/complete",
    parent: null,
    label: "査定完了ページ",
  },
  expire: {
    location: "/expire",
    parent: null,
    label: "査定回数上限ページ",
  },
  exceed: {
    location: "/exceed",
    parent: null,
    label: "査定回数上限ページ",
  },
  estimation: {
    location: "/estimation",
    parent: null,
    label: "査定結果ページ",
  },
  error: {
    location: "/error",
    parent: null,
    label: "エラーページ",
  },
  notfound: {
    location: "/404",
    parent: null,
    label: "404ページ",
  },
};

export default routings;
